<ng-container *ngIf="charts$ | async as charts; else loading">
  <cc-charts-list-toolbar
    [charts]="charts"
    [dashboard]="dashboard$ | async"
    [selectedCharts]="selectedCharts"
    (deleteSelected)="deleteSelectedCharts()"
    (addChart)="addChart()"
  ></cc-charts-list-toolbar>

  <ng-container *ngIf="charts.length; else empty">
    <div class="content">
      <div class="container grid-container">
        <cc-document
          *ngFor="let chart of charts; trackBy: trackBy"
          class="animate-fade-in"
          [selected]="selectedCharts.get(chart._id)"
          (onClick)="onChartClick(chart._id)"
          (onSelectionToggle)="onSelectionToggle(chart, $event)"
          [displaySelectionCheckbox]="true"
        >
          <div class="document-header">
            <div class="title">{{ chartUtilsService.getChartName(chart) || 'Untitled Chart' }}</div>
            <div class="subtitle text-capitalize">{{ chart.kind }}</div>
            <div class="subtitle font-weight-bold">
              <ng-container *ngIf="chart.kind === chartTypes.Quantity">
                <span i18n>Quantity to date: </span>
                {{ (chart.meta | async)?.totalQuantity }}
              </ng-container>
              &nbsp;
            </div>
          </div>
          <div class="document-body">
            <cc-quantity-chart-thumbnail
              [chart]="chart"
              *ngIf="chart.kind === chartTypes.Quantity"
            ></cc-quantity-chart-thumbnail>
            <cc-frequency-chart-thumbnail
              [chart]="chart"
              *ngIf="chart.kind === chartTypes.Frequency"
            ></cc-frequency-chart-thumbnail>
            <cc-ratio-chart-thumbnail
              [chart]="chart"
              *ngIf="chart.kind === chartTypes.Ratio"
            ></cc-ratio-chart-thumbnail>
          </div>
        </cc-document>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #empty>
  <div class="empty-chart">
    <img src="/assets/images/analytics/charts-background.svg" alt="" />
    <h3 class="mt-4 h3" i18n>Create your first Chart</h3>
    <p class="default-paragraph mt-2 text-center">
      Charts can help visualise the form data recorded in the Templates section
    </p>
    <button
      type="button"
      (click)="addChart()"
      class="mt-3 btn cc-btn-primary-constructive"
      ccSegmentCTA="Chart Add"
      data-cy="create-chart"
    >
      <i class="cc-icon cc-icon-plus"></i>
      <span>Add chart</span>
    </button>
  </div>
</ng-template>

<ng-template #loading>
  <div class="loading-spinner">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>

<router-outlet></router-outlet>
